<template>
    <div class="div tooltip" :data-tooltip="carData.query.yard">
        <button class="button is-small text-button" :class="{'bold' : isFilled}" @click="openModal" style="min-width: 55px;">
            {{ carData.query.yard }}
        </button>
        <div class="modal" :class="{'is-active': isActive }">
            <div class="modal-background" @click="isActive = !isActive"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">Yard: {{ carData.query.yard }}</p>
                    <button class="delete" aria-label="close" @click="isActive = !isActive"></button>
                </header>
                <section class="modal-card-body">
                    <table class="is-fullwidth table is-bordered is-striped">
                        <thead>
                            <tr>
                                <th width="10">Select</th>
                                <th>Name</th>
                                <th>Info</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(yard, index) in yards">
                                <td width="10">
                                    <button class="button is-info" @click="selectYard(yard.name)">
                                        <span class="icon">
                                          <i class="fas fa-check"></i>
                                        </span>
                                    </button>
                                </td>
                                <td class="subtitle">{{ yard.name }}</td>
                                <td>{{ yard.info }}</td>
                                <td width="10">
                                    <button class="button is-danger" @click="deleteYard(index, yard)">
                                        <span class="icon">
                                          <i class="fas fa-trash"></i>
                                        </span>
                                    </button>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <input v-model="newYard.name" class="input" type="text" placeholder="Type name of the yard">
                                </td>
                                <td>
                                    <input v-model="newYard.info" class="input" type="text" placeholder="Type yard info">
                                </td>
                                <td width="10">
                                    <button class="button is-primary" @click="createNewYard">
                                        <span class="icon">
                                              <i class="fas fa-save"></i>
                                            </span>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </section>
                <footer class="modal-card-foot">
                    <button class="button"  @click="isActive = !isActive">Close</button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
    import apiYards from './../../../api/apiYards'
    import apiCars from './../../../api/apiCars'
    import moment from 'moment'
    export default {
        props:['car'],
        components: {

        },
        data () {
            return {
                isActive: false,
                yards: [],
                carData:{
                    id: this.car.id,
                    query: {
                        yard: this.car.yard === null ? '---' : this.car.yard,
                    }
                },
                newYard: {
                    name: '',
                    info: ''
                }
            }
        },
        methods: {
            createNewYard(){
                apiYards
                    .createYardRequest(this.newYard)
                    .then((response) => {
                        this.yards.push(response.data)
                        this.newYard.name = ''
                        this.newYard.info = ''
                    })
                    .catch(error => console.log(error))
            },
            selectYard(name) {
                this.carData.query.yard = name
                apiCars
                    .updateCarRequest(this.carData)
                    .then((response) => {
                        this.isActive = false
                    })
                    .catch(error => console.log(error))
            },
            deleteYard(index, yard){
                apiYards
                    .deleteYardRequest(yard.id)
                    .then((response) => {
                        this.yards = this.yards.filter(item => item !== yard)
                    })
                    .catch(error => console.log(error))
            },
            openModal() {
                this.isActive = !this.isActive
                apiYards
                    .yardsListRequest()
                    .then((response) => {
                        this.yards = response.data
                    })
                    .catch(error => console.log(error))
            }
        },
        computed: {
            isFilled() {
                if (this.carData.query.yard !== '---'){
                    return  true;
                }
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>
    .text-button {
        max-width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>


// WEBPACK FOOTER //
// src/components/Cars/Columns/YardColumn.vue